import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        color: white;
        font-family: 'Montserrat', sans-serif;
    }
`;

export default GlobalStyle;